import { UPLOAD_ENTITY_TYPES } from "constants/documentUploads";
import TrackedOpportunitiesOptions from "pages/capture/OpportunitySummary/components/Options";
import MiscAnalysisOptions from "pages/miscAnalysis/MiscAnalysisDetailView/General/Options";
import ProposalOptions from "pages/proposals/ProposalSummary/components/Options";

const OPTIONS_COMPONENTS = {
  [UPLOAD_ENTITY_TYPES.PROPOSAL]: ProposalOptions,
  [UPLOAD_ENTITY_TYPES.OPPORTUNITY]: TrackedOpportunitiesOptions,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS]: MiscAnalysisOptions,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_RESEARCH]: MiscAnalysisOptions,
  [UPLOAD_ENTITY_TYPES.MISC_ANALYSIS_PROPOSAL_WRITING]: MiscAnalysisOptions,
};

export const getOptionsByEntityType = (entityType, props) => {
  const Component = OPTIONS_COMPONENTS[entityType];
  return Component ? <Component {...props} /> : null;
};
